import httpAdapter from 'axios/lib/adapters/http'
const { protocol } = location
export const baseURL = `${protocol}//${process.env.VUE_APP_API_URL}/api/v2`
export const mockBaseURL = `${protocol}//${process.env.VUE_APP_MOCK_API_URL}/api/v2`
export const adapter = httpAdapter
export const timeout = 0
